import { NextRouter } from 'next/router';

const removeQueryParam = (router: NextRouter, param: string) => {
  const searchParams = { ...router.query };
  delete searchParams?.[param];
  return searchParams;
};

export default removeQueryParam;
